// Extract the search term from the URL query parameters
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const searchTerm = urlParams.get('q');

// Initialize the Google Analytics dataLayer if not already defined
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    "event": "ga4_view_search_results",
    "ga4_data": {
        "search_term": searchTerm ? searchTerm.replace('*', '') : '',
        "search_results_count": resultCount
    }
});

// Add click event listeners for search result items and quick view buttons
document.querySelectorAll('.grid__item, .quick-product__btn').forEach(element => {
    element.addEventListener('click', function (e) {
        const el = e.currentTarget;

        // Re-extract the search term from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const searchTerm = urlParams.get('q');
        const currPage = Number(urlParams.get('page')) || 1;

        // Determine the index of the clicked item within its parent container
        let eleIndex = [...el.parentElement.children].indexOf(el);

        // If the clicked element is a quick view button, get the correct index of its associated product
        if (el.classList.contains('quick-product__btn')) {
            const parentGridItem = el.closest('.grid__item');
            if (parentGridItem) {
                eleIndex = [...parentGridItem.parentElement.children].indexOf(parentGridItem);
            }
        }

        // Adjust the index to account for pagination
        eleIndex = 12 * (currPage - 1) + eleIndex;

        // Get the item's link URL
        let itemLink = el.querySelector('a')?.getAttribute('href');
        if (!itemLink) {
            const closestAnchor = el.closest('a');
            itemLink = closestAnchor ? closestAnchor.getAttribute('href') : '';
        }

        // Get the item's title text
        let linkText = '';
        if (el.classList.contains('grid-product')) {
            const titleElement = el.querySelector('div.grid-product__title');
            linkText = titleElement ? titleElement.innerText.trim() : '';
        } else {
            const pageContentElement = el.querySelector('span.grid-search__page-content > span');
            linkText = pageContentElement ? pageContentElement.innerText.trim() : '';
        }

        // Push event data to Google Analytics
        window.dataLayer.push({
            "event": "ga4_select_search_result",
            "ga4_data": {
                "search_term": searchTerm || '',
                "search_results_count": resultCount,
                "index": eleIndex,
                "link_url": `${window.location.origin}${itemLink}`,
                "link_text": linkText
            }
        });
    });
});
